import { FlexRow, Link, Stack, Text } from "atoms";
import { AnnouncementElement } from "features/notifications";
import { constants } from "config";

function CollectivesPageAnnouncement() {
  return (
    <AnnouncementElement
      id={0}
      isDismissible={false}
      markAsRead={noop}
      message={
        <Stack gap="xs">
          <FlexRow gap="10px" justifyContent="center">
            <Text
              font="display"
              textTransform="uppercase"
              style={{ margin: 0 }}
            >
              Add Your Collective to Hug
            </Text>
            <Link
              to={constants.collectiveRequestURL}
              variant="primary"
              size="xxs"
              target="_blank"
              style={{ paddingTop: 3, paddingBottom: 2 }}
            >
              Learn More
            </Link>
          </FlexRow>
          <Text size="xxs" textAlign="center">
            A home for your creative community to get discovered & stay
            connected
          </Text>
        </Stack>
      }
    />
  );
}
export { CollectivesPageAnnouncement };
